module.exports = __webpack_public_path__ + "media/2.bf6a4a79.mp4";